import './no-video.scss'

const NoVideo = () => {
  return <section className="no-videos">No Video Found</section>
}

export default NoVideo
